import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {apiClient} from '../../../../axios/apiClient';

class AuthButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      token: JSON.parse(localStorage.getItem('aeritech_token')),
    };

    this.checkUser();
  }

  componentDidMount() {
    const token = JSON.parse(localStorage.getItem('aeritech_token'));
    if (token) {
      this.setState(
        {
          token,
        },
        () => {
          if (this.state.token) {
            this.setState({
              isLoggedIn: true,
            });
          }
        }
      );
    }
  }
  checkUser = () => {
    //TODO: Issue with the api, so returning for now
    return;
    apiClient.get('/api/Account/Welcome', {
      headers: {
        Authorization: `Bearer ${this.state.token}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState(() => {
            return { isLoggedIn: true };
          });
        }
      })
      .catch((error) => {
        this.setState(() => {
          return { isLoggedIn: false };
        });
      });
  };

  signOut = (e) => {
    localStorage.removeItem('aeritech_token');
    this.setState(() => {
      return { isLoggedIn: false };
    });
  };

  render() {
    if (!this.state.isLoggedIn) {
      return (
        <div>
          <Link to='/signin' onClick={this.props.refresh}>
            Sign In / Sign Up
          </Link>
        </div>
      );
    } else {
      return (
        <Link to='/signin' onClick={this.signOut}>
          Log Out
        </Link>
      );
    }
  }
}
export default AuthButton;
